module.exports = __webpack_public_path__ + "img/647.80b10932.png";